import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function TableOfContents() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const parts = [{
    title: 'Control total (sin drama)',
    desc: 'Vas a hacer un diagnóstico rápido para identificar:',
    bullets: ['en qué se va tu dinero', 'qué gastos te están ahorcando', 'cuáles son “fijos” pero se pueden negociar', 'y qué hábitos están saboteando tu avance']
  }, {
    title: 'Presupuesto que SÍ funciona',
    desc: 'Aquí construyes el presupuesto de 1 página, y lo aterrizas a tu vida:',
    bullets: ['gastos variables (comida/gas/niños) sin caos', 'reglas claras para gastar sin culpa', 'sistema de pagos para que no vuelvas a atrasarte']
  }, {
    title: 'Deuda: estrategia, no vergüenza',
    desc: 'Te muestro cómo salir de deudas con el método correcto para ti:',
    bullets: ['bola de nieve vs avalancha (y cómo elegir)', 'qué hacer con tarjetas sin caer de nuevo', 'cómo dejar de vivir pagando intereses']
  }, {
    title: 'Crédito (sin miedo)',
    desc: 'Aprendes lo que realmente afecta tu credit score y cómo mejorarlo sin obsesión.',
    bullets: []
  }, {
    title: 'Ahorro y paz mental',
    desc: 'Construyes tu fondo de emergencia y “sinking funds” (ahorros por metas) para que los imprevistos dejen de ser tragedia.',
    bullets: []
  }, {
    title: 'Más dinero (sin vender humo)',
    desc: 'Opciones realistas:',
    bullets: ['pedir aumento', 'cambiar de empleo con estrategia', 'ingresos extra con evaluación rápida para no perder tiempo']
  }, {
    title: 'Inversión básica (para comenzar con cabeza)',
    desc: 'Te doy un panorama claro para empezar sin pánico (conceptos esenciales y errores a evitar).',
    bullets: []
  }, {
    title: 'Mantenerlo',
    desc: 'Porque lo importante no es hacerlo 1 mes. Es sostenerlo.',
    bullets: []
  }];
  return <section className="py-24 bg-navy-800/80 relative" data-id="element-270">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-271">
        <FadeIn data-id="element-272">
          <div className="text-center mb-16" data-id="element-273">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-274">
              ¿Qué incluye el eBook?
            </h2>
            <p className="text-xl text-slate-400" data-id="element-275">
              Un vistazo al interior de tu nuevo sistema financiero.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-276">
          {parts.map((part, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-277">
              <div className={`border border-white/10 rounded-xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'bg-white/10 border-gold-500/30' : 'bg-white/5 hover:bg-white/10'}`} data-id="element-278">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" data-id="element-279">
                  <div className="flex items-center gap-4" data-id="element-280">
                    <span className="text-gold-500 font-heading text-xl font-bold opacity-80" data-id="element-281">
                      Parte {index + 1}
                    </span>
                    <h3 className="text-xl font-bold text-white" data-id="element-282">
                      {part.title}
                    </h3>
                  </div>
                  <ChevronDownIcon className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-gold-500' : ''}`} data-id="element-283" />
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-284">
                  <div className="pl-16" data-id="element-285">
                    <p className="text-slate-300 mb-4" data-id="element-286">{part.desc}</p>
                    {part.bullets.length > 0 && <ul className="space-y-2" data-id="element-287">
                        {part.bullets.map((bullet, bIndex) => <li key={bIndex} className="flex items-start gap-2 text-slate-400" data-id="element-288">
                            <span className="text-gold-500 mt-1.5 text-xs" data-id="element-289">
                              ■
                            </span>
                            <span data-id="element-290">{bullet}</span>
                          </li>)}
                      </ul>}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}